import * as d3 from 'd3';

import { storyInit, storyResize } from './graphicStory';
import { waffleInit } from './waffle';
import { mekkoInit, mekkoResize } from './marimekko';

import '../style.scss';
import '../webfonts/stylesheet.css';

const read_index = dict => {
  let index_names = {};
  let index_sorts = {};
  let index_units = {};

  index_names['year'] = 'ปี';
  index_sorts['year'] = 'ascending';
  index_units['year'] = '(ปี)';

  dict.forEach(row => {
    if (row.thai_name) {
      index_names[row.index] = row.thai_name;
      index_units[row.index] = '(' + row.thai_unit + ')';
    } else if (row.name) {
      index_names[row.index] = row.name;
    } else index_names[row.index] = row.index;

    index_sorts[row.index] = row.order ? row.order : 'ascending';
  });

  return [index_names, index_sorts, index_units];
};

async function loadData() {
  const ippdConfig = window.ippd || {};
  const dataPath = require('../data/data.csv');
  const dictPath = require('../data/dict.csv');
  const wafflePath = require('../data/waffleData.csv');
  const surveyPath = require('../data/surveyData.csv');

  let [data, dict, waffleData, surveyData] = await Promise.all([
    d3.csv(ippdConfig.dataUrl || dataPath),
    d3.csv(ippdConfig.dictUrl || dictPath),
    d3.csv(wafflePath),
    d3.csv(surveyPath),
  ]);
  data = data.map(d => {
    Object.keys(d).forEach(key => {
      if (key === 'country') d[key] = d[key];
      else d[key] = +d[key];
    });
    return d;
  });
  let [index_names, index_sorts, index_units] = read_index(dict);

  return [
    data,
    dict,
    index_names,
    index_sorts,
    index_units,
    waffleData,
    surveyData,
  ];
}

function resize() {
  storyResize();
  mekkoResize();
}

async function init() {
  let [
    data,
    dict,
    index_names,
    index_sorts,
    index_units,
    waffleData,
    surveyData,
  ] = await loadData();
  storyInit(data, dict, index_names, index_sorts, index_units, surveyData);
  waffleInit(waffleData);
  mekkoInit(waffleData);

  window.addEventListener('resize', resize);
}

init();
